<template>
    <div v-if="open" class="downgrade-modal-container">
        <div class="downgrade-modal">
            <div class="modal-wrapper">
                <div class="top-info">
                    <span class="hold-up">Hold up, think twice!</span>
                    <span class="modal-text"
                        >By downgrading, you're missing out on some serious perks! Limited
                        Booking Manager, no direct artist invites, no promotion tools and so
                        much more.</span
                    >
                </div>
                <div class="bottom-info">
                    <button class="call-to-action" @click="hideModal">
                        Nah, let’s keep my subscription plan
                    </button>
                    <div class="downgrade-action" @click="createSubscription">
                        <span>Sure, I’ll take the basic version for now</span>
                    </div>
                </div>
            </div>
        </div>
        <div @click="hideModal" class="overlay"></div>
    </div>
</template>
<script>
    export default {
        name: 'DowngradeModal',
        emits: ['confirm', 'close'],
        props: {
            open: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        watch: {
            open: function (open) {
                if (open) {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                    document.body.classList.add('modal-open')
                } else {
                    document.body.classList.remove('modal-open')
                }
            }
        },
        methods: {
            hideModal() {
                this.$emit('close')
            },
            createSubscription() {
                this.$emit('confirm')
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    @media screen and (max-width: 600px) {
        .downgrade-modal {
            width: 100%;
            overflow-y: scroll;
            max-height: 100%;
            top: 60% !important;
        }
        .hold-up {
            font-size: 38px !important;
        }
        .modal-wrapper {
            padding: 0 16px !important;
            background: black !important;
            height: 100vh;
        }
        .call-to-action {
            min-width: 0 !important;
        }
    }
    .overlay {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: black;
        opacity: 0.7;
        top: 0;
        left: 0;
    }
    .downgrade-modal {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 25;
    }
    .modal-wrapper {
        display: inline-flex;
        padding: 48px 80px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 48px;
        border-radius: 15px;
        background: #262626;
        z-index: 121;
    }
    .top-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }
    .hold-up {
        color: #f5f5f5;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .modal-text {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .bottom-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }
    .call-to-action {
        display: flex;
        align-self: stretch;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cdeb09;
        min-width: 600px;
        border: 0;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
    .downgrade-action {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #8b8b8b;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
    }
</style>
